<div class="w-full lg:grid lg:min-h-screen lg:grid-cols-2">
  <div
    class="flex min-h-screen flex-col justify-between px-6 py-12 sm:px-8 xl:px-32 xl:py-16">
    <div>
      <a href="https://atoptima.com" target="_blank">
        <img alt="Galia Logo" class="flex h-12 dark:hidden" src="/atoptima_color_v2.png" />
        <img alt="Galia Logo" class="hidden h-12 dark:flex" src="/atoptima_white_v2.png" />
      </a>
    </div>
    <div class="flex">
      <div class="w-full flex-col">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <aside class="hidden min-h-screen w-full lg:flex">
    <div class="bg-accent-main h-full w-full bg-cover bg-center">
      <div class="flex h-full flex-col items-center justify-center space-y-6">
        <div class="flex max-w-3xl flex-col items-center">
          <div class="flex max-w-xl flex-col space-y-10 rounded-md px-8 py-10">
            <div>
              <img src="/atoptima_white_v2.png" alt="Atoptima Logo" />
            </div>
          </div>
          <div class="px-12 text-white">
            <h2 class="text-xl font-medium">
              Your New-Generation Transport Optimization System
            </h2>
          </div>
        </div>
      </div>
    </div>
  </aside>
</div>
